module.exports = __webpack_public_path__ + "static/media/wasek-portfolio-footer.ba83e0dc.jpg";